import React, { useState } from "react";

/**Importar componentes visuales */
import ProductoLabel from "../etiqueta/ProductoLabel.js";
import BotoneraMasMenosCard from "../botonera/ProductoBotoneraCard.js";
import ProductoContador from "../contador/ProductoContador.js";
import BotonAgregar from "../../../../componentsUI/formularios/button/ButtonAgregar.js";

import "./ProductosCard.css";

export default function ProductoCard({
  id,
  nombre,
  precio,
  seleccionado = false,
  onSelect,
  onSelectCantidad,
  onAgregarAlCarrito,
}) {
  const [cantidadSeleccionada, setCantidadSeleccionada] = useState(0);

  return (
    <div
      className={`producto-item ${seleccionado ? "producto-seleccionado" : ""}`}
      onClick={() => {
        console.log("Click en tarjeta:", { id, nombre });
        onSelect(id);
      }}
    >
      {/* Encabezado */}
      <div className="grupo-encabezado">
        <ProductoContador cantidad={cantidadSeleccionada} />
      </div>

      {/* Información */}
      <div className="grupo-info">
        <ProductoLabel valor={nombre} editable={false} align="center" />
      </div>

      {/* Precio */}
      <div className="grupo-precio">
        <ProductoLabel
          valor={precio}
          editable={false}
          align="center"
          formato={(v) =>
            new Intl.NumberFormat("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(v || 0)
          }
        />
      </div>

      {/* Botonera */}
      <div className="grupo-botonera">
        <BotoneraMasMenosCard
          cantidadInicial={0}
          onCantidadChange={(cantidad) => {
            setCantidadSeleccionada(cantidad);
            onSelectCantidad?.({ id, nombre, precio, cantidad });
          }}
        />

        {/*  Botón Agregar */}
        <BotonAgregar
          texto="Agregar"
          className="boton-agregar"
          onClick={(e) => {
            e.stopPropagation();
            if (cantidadSeleccionada <= 0) return;

            onAgregarAlCarrito({
              id,
              nombre,
              precio,
              cantidad: cantidadSeleccionada,
            });
          }}
        />
      </div>
    </div>
  );
}
